export default __webpack_public_path__ + "static/media/platform_safe_and_secure.24df39d8.svg";